import { render, staticRenderFns } from "./ManageTarget.vue?vue&type=template&id=ae4557f4"
import script from "./ManageTarget.vue?vue&type=script&lang=js"
export * from "./ManageTarget.vue?vue&type=script&lang=js"
import style0 from "./ManageTarget.vue?vue&type=style&index=0&id=ae4557f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports